import styled from '../../../theme/styled-with-theme';

import { GlImage } from '../../Image';

export const StyledImage = styled(GlImage)`
  border-radius: ${({ theme }) => theme.borderRadius.innerBlock};
`;
